/*
 *  AWS Transcribe supported languages. For the latest list check out
 *  https://docs.aws.amazon.com/transcribe/latest/dg/supported-languages.html
 */
export const transcriptLanguages = [
  { code: 'ab-GE', name: 'Abkhaz' },
  { code: 'af-ZA', name: 'Afrikaans' },
  { code: 'ar-AE', name: 'Gulf Arabic' },
  { code: 'ar-SA', name: 'Modern Standard Arabic' },
  { code: 'ar-munsit', name: 'Munsit Arabic' },
  // { code: 'arabic-ai', name: 'Arabic (AI)' },
  { code: 'hok-breeze', name: 'Hokkien-Taigi (Breeze)' },
  { code: 'ast-ES', name: 'Asturian' },
  { code: 'az-AZ', name: 'Azerbaijani' },
  { code: 'ba-RU', name: 'Bashkir' },
  { code: 'be-BY', name: 'Belarusian' },
  { code: 'bg-BG', name: 'Bulgarian' },
  { code: 'bn-IN', name: 'Bengali' },
  { code: 'bs-BA', name: 'Bosnian' },
  { code: 'ca-ES', name: 'Catalan' },
  { code: 'ckb-IQ', name: 'Central Kurdish (Iraq)' },
  { code: 'ckb-IR', name: 'Central Kurdish (Iran)' },
  { code: 'cs-CZ', name: 'Czech' },
  { code: 'cy-WL', name: 'Welsh' },
  { code: 'da-DK', name: 'Danish' },
  { code: 'de-CH', name: 'Swiss German' },
  { code: 'de-DE', name: 'German' },
  { code: 'el-GR', name: 'Greek' },
  { code: 'en-AB', name: 'Scottish English' },
  { code: 'en-AU', name: 'Australian English' },
  { code: 'en-GB', name: 'British English' },
  { code: 'en-IE', name: 'Irish English' },
  { code: 'en-IN', name: 'Indian English' },
  { code: 'en-NZ', name: 'New Zealand English' },
  { code: 'en-US', name: 'US English' },
  { code: 'en-WL', name: 'Welsh English' },
  { code: 'en-ZA', name: 'South African English' },
  { code: 'es-ES', name: 'Spanish' },
  { code: 'es-US', name: 'US Spanish' },
  { code: 'et-ET', name: 'Estonian' },
  { code: 'eu-ES', name: 'Basque' },
  { code: 'fa-IR', name: 'Farsi' },
  { code: 'fi-FI', name: 'Finnish' },
  { code: 'fr-CA', name: 'Canadian French' },
  { code: 'fr-FR', name: 'French' },
  { code: 'gl-ES', name: 'Galician' },
  { code: 'gu-IN', name: 'Gujarati' },
  { code: 'ha-NG', name: 'Hausa' },
  { code: 'he-IL', name: 'Hebrew' },
  { code: 'hi-IN', name: 'Hindi' },
  { code: 'hr-HR', name: 'Croatian' },
  { code: 'hu-HU', name: 'Hungarian' },
  { code: 'hy-AM', name: 'Armenian' },
  { code: 'id-ID', name: 'Indonesian' },
  { code: 'is-IS', name: 'Icelandic' },
  { code: 'it-IT', name: 'Italian' },
  { code: 'ja-JP', name: 'Japanese' },
  { code: 'ka-GE', name: 'Georgian' },
  { code: 'kab-DZ', name: 'Kabyle' },
  { code: 'kk-KZ', name: 'Kazakh' },
  { code: 'kn-IN', name: 'Kannada' },
  { code: 'ko-KR', name: 'Korean' },
  { code: 'ky-KG', name: 'Kyrgyz' },
  { code: 'lg-IN', name: 'Luganda' },
  { code: 'lt-LT', name: 'Lithuanian' },
  { code: 'lv-LV', name: 'Latvian' },
  { code: 'mhr-RU', name: 'Meadow Mari' },
  { code: 'mk-MK', name: 'Macedonian' },
  { code: 'ml-IN', name: 'Malayalam' },
  { code: 'mn-MN', name: 'Mongolian' },
  { code: 'mr-IN', name: 'Marathi' },
  { code: 'ms-MY', name: 'Malay' },
  { code: 'mt-MT', name: 'Maltese' },
  { code: 'nl-NL', name: 'Dutch' },
  { code: 'no-NO', name: 'Norwegian Bokmål' },
  { code: 'or-IN', name: 'Odia' },
  { code: 'pa-IN', name: 'Punjabi' },
  { code: 'pl-PL', name: 'Polish' },
  { code: 'ps-AF', name: 'Pashto' },
  { code: 'pt-BR', name: 'Brazilian Portuguese' },
  { code: 'pt-PT', name: 'Portuguese' },
  { code: 'ro-RO', name: 'Romanian' },
  { code: 'ru-RU', name: 'Russian' },
  { code: 'rw-RW', name: 'Kinyarwanda' },
  { code: 'si-LK', name: 'Sinhala' },
  { code: 'sk-SK', name: 'Slovak' },
  { code: 'sl-SI', name: 'Slovenian' },
  { code: 'so-SO', name: 'Somali' },
  { code: 'sr-RS', name: 'Serbian' },
  { code: 'su-ID', name: 'Sundanese' },
  { code: 'sv-SE', name: 'Swedish' },
  { code: 'sw-BI', name: 'Swahili (Burundi)' },
  { code: 'sw-KE', name: 'Swahili (Kenya)' },
  { code: 'sw-RW', name: 'Swahili (Rwanda)' },
  { code: 'sw-TZ', name: 'Swahili (Tanzania)' },
  { code: 'sw-UG', name: 'Swahili (Uganda)' },
  { code: 'ta-IN', name: 'Tamil' },
  { code: 'te-IN', name: 'Telugu' },
  { code: 'th-TH', name: 'Thai' },
  { code: 'tl-PH', name: 'Tagalog' },
  { code: 'tr-TR', name: 'Turkish' },
  { code: 'tt-RU', name: 'Tatar' },
  { code: 'ug-CN', name: 'Uyghur' },
  { code: 'uk-UA', name: 'Ukrainian' },
  { code: 'uz-UZ', name: 'Uzbek' },
  { code: 'vi-VN', name: 'Vietnamese' },
  { code: 'wo-SN', name: 'Wolof' },
  { code: 'yue-HK', name: 'Cantonese' },
  { code: 'zh-CN', name: 'Mandarin Chinese (Mainland)' },
  { code: 'zh-TW', name: 'Traditional Chinese (Taiwan)' },
  { code: 'zu-ZA', name: 'Zulu' },
];

export const transcriptionLanguageCodes = transcriptLanguages.map(language => language.code);

/**
 * Language codes that use external transcription providers (not AWS Transcribe).
 * These skip AWS vocabulary creation and other AWS Transcribe-specific steps.
 */
export const externalTranscriptionProviderCodes: string[] = [
  'arabic-ai',
  'ar-munsit',
  'hok-breeze',
];

export function isExternalTranscriptionProvider(languageCode: string | null | undefined): boolean {
  return !!languageCode && externalTranscriptionProviderCodes.includes(languageCode);
}

export function getLanguageCode(input: string): string | undefined {
  if (transcriptionLanguageCodes.indexOf(input) !== -1) {
    return input;
  }

  return undefined;
}

const DEFAULT_LANG_CODE = 'en-US';

export function getLanguageForCode(code: string | null | undefined): string {
  const lang = transcriptLanguages.find(val => val.code === code);
  if (!lang) return getLanguageForCode(DEFAULT_LANG_CODE);

  return lang.name;
}

const RTL_LANGUAGE_CODES = new Set([
  'ar',
  'ckb',
  'fa',
  'he',
  'ps',
  'ug',
  'ur',
]);

export function getLanguageDirection(languageCode: string | null | undefined): 'ltr' | 'rtl' {
  if (!languageCode) return 'ltr';

  const normalizedCode = languageCode.trim().toLowerCase();
  const primarySubtag = normalizedCode.split('-')[0];

  return RTL_LANGUAGE_CODES.has(normalizedCode) || RTL_LANGUAGE_CODES.has(primarySubtag)
    ? 'rtl'
    : 'ltr';
}

/*
 *  AWS Translate supported languages. For the latest list check out
 *  https://docs.aws.amazon.com/translate/latest/dg/what-is-languages.html
 */
export const translateLanguages = [
  { name: 'Afrikaans', code: 'af' },
  { name: 'Albanian', code: 'sq' },
  { name: 'Amharic', code: 'am' },
  { name: 'Arabic', code: 'ar' },
  { name: 'Armenian', code: 'hy' },
  { name: 'Azerbaijani', code: 'az' },
  { name: 'Bengali', code: 'bn' },
  { name: 'Bosnian', code: 'bs' },
  { name: 'Bulgarian', code: 'bg' },
  { name: 'Catalan', code: 'ca' },
  { name: 'Chinese (Simplified)', code: 'zh' },
  { name: 'Chinese (Traditional)', code: 'zh-TW' },
  { name: 'Croatian', code: 'hr' },
  { name: 'Czech', code: 'cs' },
  { name: 'Danish', code: 'da' },
  { name: 'Dari', code: 'fa-AF' },
  { name: 'Dutch', code: 'nl' },
  { name: 'English', code: 'en' },
  { name: 'Estonian', code: 'et' },
  { name: 'Farsi (Persian)', code: 'fa' },
  { name: 'Filipino, Tagalog', code: 'tl' },
  { name: 'Finnish', code: 'fi' },
  { name: 'French', code: 'fr' },
  { name: 'French (Canada)', code: 'fr-CA' },
  { name: 'Georgian', code: 'ka' },
  { name: 'German', code: 'de' },
  { name: 'Greek', code: 'el' },
  { name: 'Gujarati', code: 'gu' },
  { name: 'Haitian Creole', code: 'ht' },
  { name: 'Hausa', code: 'ha' },
  { name: 'Hebrew', code: 'he' },
  { name: 'Hindi', code: 'hi' },
  { name: 'Hungarian', code: 'hu' },
  { name: 'Icelandic', code: 'is' },
  { name: 'Indonesian', code: 'id' },
  { name: 'Irish', code: 'ga' },
  { name: 'Italian', code: 'it' },
  { name: 'Japanese', code: 'ja' },
  { name: 'Kannada', code: 'kn' },
  { name: 'Kazakh', code: 'kk' },
  { name: 'Korean', code: 'ko' },
  { name: 'Latvian', code: 'lv' },
  { name: 'Lithuanian', code: 'lt' },
  { name: 'Macedonian', code: 'mk' },
  { name: 'Malay', code: 'ms' },
  { name: 'Malayalam', code: 'ml' },
  { name: 'Maltese', code: 'mt' },
  { name: 'Marathi', code: 'mr' },
  { name: 'Mongolian', code: 'mn' },
  { name: 'Norwegian (Bokmål)', code: 'no' },
  { name: 'Pashto', code: 'ps' },
  { name: 'Polish', code: 'pl' },
  { name: 'Portuguese (Brazil)', code: 'pt' },
  { name: 'Portuguese (Portugal)', code: 'pt-PT' },
  { name: 'Punjabi', code: 'pa' },
  { name: 'Romanian', code: 'ro' },
  { name: 'Russian', code: 'ru' },
  { name: 'Serbian', code: 'sr' },
  { name: 'Sinhala', code: 'si' },
  { name: 'Slovak', code: 'sk' },
  { name: 'Slovenian', code: 'sl' },
  { name: 'Somali', code: 'so' },
  { name: 'Spanish', code: 'es' },
  { name: 'Spanish (Mexico)', code: 'es-MX' },
  { name: 'Swahili', code: 'sw' },
  { name: 'Swedish', code: 'sv' },
  { name: 'Tamil', code: 'ta' },
  { name: 'Telugu', code: 'te' },
  { name: 'Thai', code: 'th' },
  { name: 'Turkish', code: 'tr' },
  { name: 'Ukrainian', code: 'uk' },
  { name: 'Urdu', code: 'ur' },
  { name: 'Uzbek', code: 'uz' },
  { name: 'Vietnamese', code: 'vi' },
  { name: 'Welsh', code: 'cy' },
  { name: 'Yoruba', code: 'yo' },
];

export const translateLanguagesCodes = translateLanguages.map(language => language.code);
